import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'c-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  @Output() confirm: EventEmitter<boolean> = new EventEmitter();
  @Input() message: string;
  private subscription: Subscription;

  readonly destroy: () => void;
  readonly beforeDestroy = (from: 'container' | 'content' | 'outside') => from != 'content' && this.confirm.next(false);

  constructor() { }

  ngOnInit() {
    this.subscription = this.confirm.pipe(
      first()
    ).subscribe(() => {
      this.destroy();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
